module.exports = __webpack_public_path__ + "img/profile-next.bbf1db9a.jpg";